// src/components/ActivityFilter.jsx
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
} from "@mui/material";
import theme from "../../configs/theme";

export default function ActivityFilter({ onFilterChange }) {
  const [search, setSearch] = useState("");
  const [operation, setOperation] = useState("");
  const [dateFilter, setDateFilter] = useState("");

  // Notifica al componente padre cada vez que cambia un filtro
  useEffect(() => {
    onFilterChange({
      search,
      operation,
      dateFilter,
    });
  }, [search, operation, dateFilter, onFilterChange]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        width: "100%",
        bgcolor: theme.tableColors.header,
        p: 1,
        borderRadius: 2,
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ display: "flex", gap: 2, flex: 1 }}>
        <TextField
          label="Buscar por título"
          variant="outlined"
          fullWidth
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            bgcolor: theme.tableColors.body,
            borderRadius: 1,
          }}
          InputProps={{
            sx: {
              bgcolor: theme.tableColors.body,
            },
          }}
        />

        <FormControl fullWidth>
          <InputLabel>Operación</InputLabel>
          <Select
            value={operation}
            label="Operación"
            onChange={(e) => setOperation(e.target.value)}
            sx={{
              bgcolor: theme.tableColors.body,
              borderRadius: 1,
              color: "black"
            }}
          >
            <MenuItem value="">Todas</MenuItem>
            <MenuItem value="Pagos">Pagos</MenuItem>
            <MenuItem value="Compras">Compras</MenuItem>
            <MenuItem value="Ingresos">Ingresos</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Fecha</InputLabel>
          <Select
            value={dateFilter}
            label="Fecha"
            onChange={(e) => setDateFilter(e.target.value)}
            sx={{
              bgcolor: theme.tableColors.body,
              borderRadius: 1,
              color: "black"
            }}
          >
            <MenuItem value="">Todas</MenuItem>
            <MenuItem value="hoy">Hoy</MenuItem>
            <MenuItem value="ayer">Ayer</MenuItem>
            <MenuItem value="semana">Última semana</MenuItem>
            <MenuItem value="15dias">Últimos 15 días</MenuItem>
            <MenuItem value="mes">Último mes</MenuItem>
            <MenuItem value="año">Último año</MenuItem>
          </Select>
        </FormControl>
      </Box>
      
    </Box>
  );
}
